import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-input border border-transparent font-display font-semibold transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&.bg-brand]:!text-black [&.hover\\:bg-brand-hover]:!text-black",
  {
    variants: {
      variant: {
        primary: "bg-brand text-black hover:bg-brand-hover shadow-md hover:shadow-lg",
        success: "bg-success text-background hover:bg-success/90 shadow-md hover:shadow-lg",
        danger: "bg-danger text-background hover:bg-danger/90 shadow-md hover:shadow-lg",
        secondary:
          "bg-background-raised text-foreground border-border-subtle hover:border-brand-border hover:bg-background-raised/80",
        ghost: "bg-transparent text-foreground hover:bg-background-raised",
      },
      size: {
        sm: "h-8 px-3 text-label",
        md: "h-10 px-4 text-body-sm",
        lg: "h-12 px-6 text-body",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  ),
)
Button.displayName = "Button"

export { buttonVariants }
